import { useDebugTools } from '@/hooks'
import { useLoadScript } from '@react-google-maps/api'
import { ContextProviders } from 'context'
import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ReactQuery } from './ReactQuery'

interface IProps {
    children: React.ReactNode
}

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_MAP_API_KEY

export function Providers({ children }: IProps) {
    const { loadError } = useLoadScript({
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        libraries: ['places'],
    })

    if (loadError) {
        console.error(loadError)
    }

    useDebugTools()

    return (
        <ReactQuery>
            <BrowserRouter basename="/">
                <ContextProviders>{children}</ContextProviders>
            </BrowserRouter>
        </ReactQuery>
    )
}
